import type { ProfileResponse } from "@/infrastructure/services/profileService";
import type { BusinessImage, CategoryOption, ProfileFormData } from "../../types";

function mapImage(item?: NonNullable<NonNullable<ProfileResponse["imagensNegocio"]>["banner"]> | null): BusinessImage | null {
  return item
    ? { id: item.id, type: item.tipo, url: item.url, altText: item.alt_text || "" }
    : null;
}

export function mapProfile(data: ProfileResponse): Partial<ProfileFormData> {
  const preference =
    data.preferencia === "COMPLETO"
      ? "full_address"
      : data.preferencia === "ONLINE"
        ? "online_or_on_request"
        : "neighborhood_city";

  return {
    fullName: data.nome || "",
    email: data.email || "",
    cpf: data.cpf || "",
    phone: data.contato || "",
    isDisabledPerson: data.pcd || false,
    disabilityType: data.deficiencia || "",
    isAtypicalMother: data.maeAtipica || false,
    businessName: data.titulo || "",
    cnpj: data.cnpj || "",
    website: data.website || "",
    businessCategory: data.categoria || "",
    participatesInAssociation: data.associada || false,
    associationName: data.instituto || "",
    instagram: data.instagram || "",
    facebook: data.facebook || "",
    tiktok: data.tiktok || "",
    businessDescription: data.descricao || "",
    zipCode: data.cep || "",
    address: data.rua || "",
    addressNumber: data.numero || "",
    addressComplement: data.complemento || "",
    neighborhood: data.bairro || "",
    city: data.municipio || "",
    locationDisplayPreference: preference,
    existingCoverImage: mapImage(data.imagensNegocio?.banner),
    coverImageAlt: data.imagensNegocio?.banner?.alt_text || "",
    existingLogoImage: mapImage(data.imagensNegocio?.logo),
    logoImageAlt: data.imagensNegocio?.logo?.alt_text || "",
  };
}

export function normalizeCategory(
  value: string,
  categories: CategoryOption[],
) {
  if (categories.some((category) => category.value === value)) return value;
  return (
    categories.find(
      (category) => category.label.toLowerCase() === value.toLowerCase(),
    )?.value ?? value
  );
}

